export const truncateFromCenter = (value: string): string => {
    return value.substring(0, 8) + '...' + value.substring(value.length - 3, value.length);
}